// TemplateSelectionModal.jsx (MODIFIED)

import React, { useEffect, useState } from 'react'; // <-- Import useState
import { Modal, Button, Row, Col, Typography } from 'antd';
import { ArrowLeftOutlined, CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

// IMPORTANT: Import the new component
import CertificateEditModal from './CertificateEditModal'; 
import { getcertificateTypes } from '../../services/doctor/certificate/certificate';

const { Title } = Typography;

// Mock data for the template buttons (using the templates from the image)
const templates = [
  'Fitness', 'Leave after illness', 'Leave during illness', 'Swimming',
  'Fitness w/o Immunization', 'Fitness adult', 'Mother Leave', 'Fit to fly', 'Discharge Summary',
  'Metallic Implants', 'Make your Own Form', 
];

const TemplateSelectionModal = ({ visible, onClose,appointmentData }) => {
  // State to manage the visibility of the NEW edit modal
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  // State to track which template was selected
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [isTemplateSelectionModalClose, setIsTemplateSelectionModalClose] = useState(false);

  // Handler for selecting a template button
  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setIsEditModalVisible(true); // Open the Edit modal
    // onClose(); // Optional: Close the selection modal immediately
  };
  
  // Close handler for the Edit Modal
  const handleEditModalClose = () => {
    setIsEditModalVisible(false);
    setSelectedTemplate('');
  };

    const fetchCertificateTypes = async () => {
      try {
        setLoading(true);
        const result = await getcertificateTypes();
        if (result.success) {
         
          setTemplates(result.data);
          setLoading(false);
        } else {
          // Optionally handle error
          setTemplates([]);
        }
      } catch (err) {
        // Optionally handle error
        setTemplates([]);
      }
    };
  useEffect(()=>{
    fetchCertificateTypes();
  },[])  


  // Function to render the template buttons
  const renderTemplates = () => (
    <Row gutter={[16, 16]}> 
      {templates.map((template, index) => (
        <Col key={index}> 
          <Button
            size="large" 
            type="default" 
            style={{ 
                borderRadius: '20px', 
                padding: '0 20px', 
                height: '40px'
            }}
            // MODIFIED: Use the new handler
            onClick={() => handleTemplateSelect(template)}
          >
            {template?.name}
          </Button>
        </Col>
      ))}
    </Row>
  );
  
  // Custom header remains the same
  const customHeader = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 24px',
        backgroundColor: '#00bfff', 
        color: 'white',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ArrowLeftOutlined
          style={{ fontSize: '24px', cursor: 'pointer' }}
          onClick={onClose}
        />
      </div>
      
      <Title level={4} style={{ color: 'white', margin: 0, fontWeight: 500 }}>
        Select Template
      </Title>

      <CloseOutlined
        style={{ fontSize: '24px', cursor: 'pointer' }}
        onClick={onClose}
      />
    </div>
  );

  return (
    <>
      {/* The TEMPLATE SELECTION MODAL */}
      <Modal
        title={null} 
        open={visible}
        onCancel={onClose}
        footer={null} 
        width={750} 
        maskClosable={true}
        styles={{
          header: { padding: 0 },
          body: { padding: '0' }, 
          content: { borderRadius: '8px' }
        }}
        closeIcon={null} 
      >
        {customHeader}

        <div style={{ padding: '24px' }}>
          {renderTemplates()}
        </div>
      </Modal>

      {/* The NEW CERTIFICATE EDIT MODAL */}
      {selectedTemplate && (
        <CertificateEditModal 
          visible={isEditModalVisible}
          onClose={handleEditModalClose}
          templateType={selectedTemplate}
          appointmentData={appointmentData}
          isTemplateSelectionModalClose={() => setIsTemplateSelectionModalClose(true)}
        />
      )}
    </>
  );
};

TemplateSelectionModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  appointmentData: PropTypes.object.isRequired,
};

export default TemplateSelectionModal;